import formBaseMixin from '@/components/form/form-base-mixin'
import hasMixin from '@/mixins/has-mixin'

export default {
  mixins: [formBaseMixin, hasMixin],
  title: function () {
    return this.title
  },
  data() {
    return {
      fields: {
        name: '',
        start_year: '',
        end_year: '',
        measure_id: '',
        type_table: 1,
        order: null,
      },
    }
  },
  computed: {
    title() {
      if (this.$route.query.checkedReg) {
        if (this.$route.query.checkedReg != 0) {
          return 'Редактирование'
        }
      }
      return 'Добавление'
    },
    item() {
      return this.$store.getters.readUrlEndpoint(
        this.getItemEndpoint(this.$route)
      )
    },
    measureTypes() {
      let measures = this.$store.getters.readUrlEndpoint(
        this.getCollectionEndpoint()
      ).measure
      if (this.isFromOperator) {
        measures = measures.filter((item) => item.name.includes('шт'))
      }
      return measures
    },
    typeTable() {
      return [
        { id: 1, name: 'Целевые показатели' },
        { id: 2, name: 'Баланс количественных характеристик' },
      ]
    },
  },
  methods: {
    closeForm() {
      if (!this.isFromOperator) {
        this.$refs.modalForm.redirectToPrev()
      } else {
        this.$emit('closeModalOperator')
      }
    },
    additionalValidate: async function (hasError = false, errors = {}) {
      if (this.fields.start_year || this.fields.end_year) {
        if (!this.fields.start_year) {
          errors.start_year = 'Укажите начальный год'
          hasError = true
        }
        if (!this.fields.end_year) {
          errors.end_year = 'Укажите конечный год'
          hasError = true
        }
        if (
          hasError === false &&
          this.fields.end_year < this.fields.start_year
        ) {
          hasError = true
          errors.end_year = 'Конечный год должен быть больше начального'
        }
      }
      console.error(errors)
      if (hasError === true) {
        this.formValidator.handleServerErrors({ data: { errors } }, this)
        return Promise.reject(1)
      }
      return Promise.resolve(1)
    },
    prepareFieldsForSend(fields = {}) {
      if (fields.order === null || fields.order === undefined) {
        fields.order = 1
      } else {
        fields.order = +fields.order
      }
      return fields
    },
    initFieldsAfterLoad() {
      if (this.item) {
        this.fields = Object.assign({}, this.item)
      }
    },
  },
  asyncData({ store, route, fromRoute, methods }) {
    let promises = []
    if (methods.getItemEndpoint(route, fromRoute) !== null) {
      promises.push(
        store.dispatch('updateUrlEndpoint', {
          endpoint: methods.getItemEndpoint(route, fromRoute),
        })
      )
    }

    promises.push(
      store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getCollectionEndpoint(),
        fromCache: true,
      })
    )

    if (promises.length === 0) {
      return Promise.resolve(1)
    }

    return Promise.all(promises)
  },
}
